import React from "react";
import StyledResendLink from "./StyledResendLink";
import { BUTTON_LABELS } from "../../constants/lang";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const ResendLink = () => {
  return (
    <StyledResendLink>
      <Box className="resend-wrap">
        <Box className="resend-header">
          <Box className="circleIcon"></Box>
          <Box className="header">Unable to send reset link</Box>
        </Box>
        <Box className="body-wrap">
          <Typography className="body-text">
            We’re sorry, but we couldn’t send the password reset link at this
            time. Please check your email for any errors and try again. If the
            issue persists, feel free to contact our support team for
            assistance.
          </Typography>
        </Box>
        <Box className="button-wrap">
          <Button
            // isLoading={isLoading}
            // disabled={isLoading}
            type="submit"
            variant="contained"
            color="primary"
            className="submit-btn"
            aria-label="submit"
          >
            {BUTTON_LABELS.CONTACT_SUPPORT}
          </Button>
          <Box className="backLogin" aria-label="login button">
            <Link to="/Login" aria-label="login button">
              {BUTTON_LABELS.BACK_TO_LOGIN}
            </Link>
          </Box>
        </Box>
      </Box>
    </StyledResendLink>
  );
};

export default ResendLink;
